<template>
    <article class="bg-gray-50 rounded-lg shadow-sm" :aria-labelledby="headlineId">
        <div
            class="p-2 grid grid-cols-[[link]_auto_[status]_minmax(80px,max-content)] grid-flow-col items-center gap-12"
        >
            <div class="col-[link] text-sm text-gray-900 flex justify-between font-bold">
                <TextLink :id="headlineId" :to="linkTarget">
                    {{ linkText }}
                </TextLink>
            </div>
            <Badge class="col-[status] justify-self-end" size="Extra-Small" :variant="statusBadgeVariant">
                {{ statusBadgeLabel }}
            </Badge>
        </div>
    </article>
</template>

<script setup lang="ts">
import Badge, { BadgeVariant } from '@/components/Badge/Badge.vue';
import TextLink from '@/components/TextLink/TextLink.vue';
import { nanoid } from 'nanoid';
import { RouteLocationRaw } from 'vue-router';

type ProjectCardProps = {
    linkTarget: RouteLocationRaw;
    linkText: string;
    statusBadgeVariant: BadgeVariant;
    statusBadgeLabel: string;
    helpText?: string;
    hasBorderBottom?: boolean;
};

defineProps<ProjectCardProps>();
const headlineId = nanoid();
</script>
